import { FC, SVGProps } from "react";

const VectorFloor: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="210"
      height="727"
      viewBox="0 0 210 727"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M8.57268 726.916C7.51436 727.233 6.40002 726.631 6.08374 725.573L0.929672 708.326C0.613388 707.268 1.21494 706.154 2.27325 705.837C3.33157 705.521 4.44591 706.123 4.76219 707.181L9.34358 722.511L24.6736 717.93C25.732 717.613 26.8463 718.215 27.1626 719.273C27.4789 720.332 26.8773 721.446 25.819 721.762L8.57268 726.916ZM209.072 0C209.072 227.391 131.887 499.716 9.75993 725.95L6.24007 724.05C128.113 498.284 205.072 226.609 205.072 0H209.072Z"
        fill="white"
      />
    </svg>
  );
};

export default VectorFloor;
